import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import { Box, IconButton, Typography } from '@mui/material'

import { fromRecipe } from '@/utils/matisseV2/fromRecipe'

import PieChart from './PieChart'

type DentinRecipePieChartType = {
  handleDentinIndexChange: (e: any, value: number) => void
  dentinIndex: number
  data: Record<string, any>
  isSingleOnCanvas?: boolean
  showBrand?: boolean
}

function DentinRecipePieChart(props: DentinRecipePieChartType) {
  const { handleDentinIndexChange, dentinIndex, data, isSingleOnCanvas } = props

  const layer1 = fromRecipe(data?.recipe_layer1?.[dentinIndex])
  const layer2 = fromRecipe(data?.recipe_layer2?.[dentinIndex])
  const hasLayer1 = layer1.names.length > 0 && layer1.ratios.length > 0
  const hasLayer2 = layer2.names.length > 0 && layer2.ratios.length > 0

  const maxIndex =
    Math.max(
      data?.recipe_layer1?.length ?? 0,
      data?.recipe_layer2?.length ?? 0,
    ) - 1

  return (
    <>
      {!(dentinIndex === 0 && dentinIndex === maxIndex) && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent={'space-between'}
        >
          <IconButton
            size="small"
            disabled={dentinIndex === 0}
            onClick={(e) => handleDentinIndexChange(e, dentinIndex - 1)}
            sx={{
              p: 0,
              width: 28,
              height: 28,
            }}
          >
            <ArrowLeftIcon
              sx={{
                fontSize: '26px',
                color: dentinIndex !== 0 ? '#90CAF9' : 'gray',
              }}
            />
          </IconButton>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
            {dentinIndex + 1}/{maxIndex + 1}
          </Typography>
          <IconButton
            size="small"
            disabled={dentinIndex === maxIndex}
            onClick={(e) => handleDentinIndexChange(e, dentinIndex + 1)}
            sx={{
              p: 0,
              width: 28,
              height: 28,
            }}
          >
            <ArrowRightIcon
              sx={{
                fontSize: '26px',
                color: dentinIndex !== maxIndex ? '#90CAF9' : 'gray',
              }}
            />
          </IconButton>
        </Box>
      )}

      <Box display="flex" justifyContent="center" gap={1}>
        {hasLayer1 && (
          <Box
            width={isSingleOnCanvas ? '100%' : '50%'}
            px={1}
            textAlign="center"
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '4px',
              }}
            >
              {layer1.opacityCategory && (
                <Typography
                  variant="body2"
                  sx={{
                    textTransform: 'capitalize',
                    bgcolor: 'rgba(33, 33, 33, 0.80)',
                    fontSize: '12px',
                    lineHeight: '20px',
                    letterSpacing: '0.25px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {layer1.opacityCategory}
                </Typography>
              )}
            </Box>
            <PieChart
              labels={layer1.names}
              values={layer1.ratios}
              height={'78px'}
              width={'78px'}
            />
          </Box>
        )}

        {hasLayer2 && (
          <Box width="50%" px={1} textAlign="center">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '4px',
              }}
            >
              {layer2.opacityCategory && (
                <Typography
                  variant="body2"
                  sx={{
                    textTransform: 'capitalize',
                    bgcolor: 'rgba(33, 33, 33, 0.80)',
                    fontSize: '12px',
                    lineHeight: '20px',
                    letterSpacing: '0.25px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {layer2.opacityCategory}
                </Typography>
              )}
            </Box>
            <PieChart
              labels={layer2.names}
              values={layer2.ratios}
              height={'78px'}
              width={'78px'}
            />
          </Box>
        )}
      </Box>
    </>
  )
}

export default DentinRecipePieChart
